import React from "react";
import { Button, Container, Row, Col } from "reactstrap";
import styles from "../../styles/public/service-selector.module.css";

const ServiceSelector = ({
    services,
    selectedService,
    setSelectedService,
    onServiceSelected,
}) => {
    return (
        <Container className={styles["service-selector"]}>
            <Row className={styles["service-options"]}>
                {services.map((service, index) => (
                    <Col key={service.id} xs={12} md={6} xl={6} className="justify-content-center mb-3 gap-2">
                        <Button
                            block
                            key={index}
                            className={`${styles["service-button"]} ${selectedService === service.id ? styles.selected : ""}`}
                            onClick={() => {
                                setSelectedService(service.id);
                                onServiceSelected(service);
                            }} 
                        >
                            {service.title}
                        </Button> 
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default ServiceSelector;
